import api from '../utils/api';
import type {
  EmailTemplate,
  CreateEmailTemplateDto,
  UpdateEmailTemplateDto,
  PreviewEmailTemplateDto,
  PreviewEmailTemplateResponse,
  EmailTemplateFilters
} from '../types/emailTemplate.types';
import type { PaginatedResponse, QueryParams } from '../types/common.types';

export const emailTemplatesService = {
  getAll: async (params?: QueryParams & EmailTemplateFilters): Promise<EmailTemplate[]> => {
    const response = await api.get('/email-templates', { params });
    return response.data;
  },

  getCurrent: async (): Promise<EmailTemplate[]> => {
    const response = await api.get('/email-templates/current');
    return response.data;
  },

  getById: async (id: string): Promise<EmailTemplate> => {
    const response = await api.get(`/email-templates/${id}`);
    return response.data;
  },

  create: async (data: CreateEmailTemplateDto): Promise<EmailTemplate> => {
    const response = await api.post('/email-templates', data);
    return response.data;
  },

  update: async (id: string, data: UpdateEmailTemplateDto): Promise<EmailTemplate> => {
    const response = await api.put(`/email-templates/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/email-templates/${id}`);
  },

  preview: async (id: string, data: PreviewEmailTemplateDto): Promise<PreviewEmailTemplateResponse> => {
    const response = await api.post(`/email-templates/${id}/preview`, data);
    return response.data;
  },

  restoreVersion: async (id: string, versionNumber: number): Promise<EmailTemplate> => {
    const response = await api.post(`/email-templates/${id}/restore/${versionNumber}`);
    return response.data;
  }
};

export default emailTemplatesService;
